import { useState } from 'react';
import { Size } from 're-resizable';

import { getFromLocalStorage, putInLocalStorage } from 'widget/actions';

const defaultSize = { height: 654, width: 368 };

const getSize = (): Size => {
  const size = getFromLocalStorage<Size>('whatcrmWidgetSize');

  if (!size) return defaultSize;
  else if (typeof size == 'string') return defaultSize;

  return size;
};

const useResize = () => {
  const [size, setSize] = useState(getSize());

  const updateSize = (value: Size) => {
    setSize(value);

    putInLocalStorage(
      'whatcrmWidgetSize',
      JSON.stringify({ height: value.height, width: value.width }),
    );
  };

  return { defaultSize, size, updateSize };
};

export default useResize;
